export default __webpack_public_path__ + "static/media/mobile-app-bg.5cbb4860.jpg";